module.exports = __webpack_public_path__ + "static/media/warning.edc04d51.svg";